import React, { useEffect, useState } from 'react';
import InvoicesService from '../Services/InvoicesService';
import LocalService from '../Services/LocalService';
import { useToasts } from 'react-toast-notifications';
import AuthService from '../Services/AuthService';
import { Row, Col, Button, Input, Table, Card, CardBody } from 'reactstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { setTranslations, setDefaultLanguage, withTranslation, t } from 'react-multi-lang';
import {
    faRefresh
} from "@fortawesome/free-solid-svg-icons";

const Invoices = ({t}) => {
    const [invoices, setInvoices] = useState([]);
    const [vehicles, setVehicles] = useState([]);
    const [config, setConfig] = useState({});
    const [selectedVehicle, setSelectedVehicle] = useState('');
    const [selectedInvoice, setSelectedInvoice] = useState('');
    const [customPlate, setCustomPlate] = useState(false);

    const localService = new LocalService();
    const invoicesService = new InvoicesService();
    const authService = new AuthService();
    const { addToast } = useToasts();

    useEffect(() => {
        getVehicles();
        getInvoices();
        setConfig(authService.getConfig());
    }, []);

    const getVehicles = () => {
        localService.getVehicles().then(r => {
            setVehicles(r);
            if(r.length === 0){
                addToast(t('vehicles.noVehiclesFound'), { appearance: 'warning', autoDismiss: true, autoDismissTimeout: 4000 });
            }
        });
    };

    const getInvoices = () => {
        invoicesService.getInvoices().then(r => {
            setInvoices(r);
        }).catch(e => {
            addToast(t('vehicles.invoicesNoResponse'), { appearance: 'error', autoDismiss: true, autoDismissTimeout: 4000 });
        })
    };

    const assignVehicle = () => {
        invoicesService.assignVehicles(selectedVehicle, selectedInvoice, invoices).then(r => {
            addToast(t('vehicles.matchCompleted'), { appearance: 'success', autoDismiss: true, autoDismissTimeout: 4000 });
            setSelectedInvoice('');
            setSelectedVehicle('');
        }).catch(e => {
            addToast(t('vehicles.matchError'), { appearance: 'error', autoDismiss: true, autoDismissTimeout: 4000 });
        });
    }

    return  <Card>
            <CardBody>
                <Row>
                    <Col md="3">
                        <Button size="sm" className="float-end" color="info" onClick={getVehicles}><FontAwesomeIcon icon={faRefresh} /> </Button>
                        <h3>{t('vehicles.vehiclesInQuarry')}</h3>
                        

                        {
                            vehicles.map(v => {
                                return <Button key={v} style={{margin: '20px'}} block color={v === selectedVehicle ? 'primary' : 'info'}
                                            onClick={() => {
                                            v === selectedVehicle ? setSelectedVehicle('') : setSelectedVehicle(v);
                                            setCustomPlate(false);
                                            }}>{v}</Button>
                            })
                        }
                        <br />
                        <hr />
                        {t('vehicles.noVehicleMessage')}:
                        <Input type="text" onChange={(e) => {
                            setSelectedVehicle(e.target.value);
                            setCustomPlate(true);
                        }} />

                        <hr />
                        <Button color="primary" block onClick={() => assignVehicle(config)}>{t('vehicles.match')}</Button>
                    
                    </Col>
                    <Col md="9"><Button color="warning" className="float-end" onClick={() => getInvoices()}>{t('volumes.search')}</Button>
                        <h3>{t('vehicles.document')}</h3>
                        <Table responsive>
                            <thead>
                                <tr>
                                    <th>{t('vehicles.document')}</th>
                                    <th>{t('vehicles.relatedParty')}</th>
                                    <th>{t('vehicles.code')}</th>
                                    <th>{t('vehicles.block')}</th>
                                    <th>{t('vehicles.qty')}</th>
                                </tr>
                            </thead>
                            <tbody>
                            {
                            invoices.filter(i => {
                                if(authService.getConfig().WHCode === '4'){
                                    return true;
                                }
                                else{
                                    if(i.WHCode === authService.getConfig().ordersWhCode){
                                        return true;
                                    }
                                    else{
                                        return false;
                                    }
                                }
                            }).sort((i1, i2) => i1.ADCode > i2.ADCode ? 1 : -1).map((i, index) => {
                                return <tr key={index} className={i.ADCode === selectedInvoice ? 'bg-primary' : ''} onClick={() => {
                                i.ADCode === selectedInvoice ? setSelectedInvoice('') : setSelectedInvoice(i.ADCode)
                                }}>
                                    <td>{i.ADCode}</td>
                                    <td>{i.ClientName}</td>
                                    <td>{i.Code} - {i.Description}</td>
                                    <td>{i.fStockDim1}</td>
                                    <td>{i.OpenQty.toFixed(2)} {i.fMUMainCode}</td>
                                </tr>
                            })
                            }
                            </tbody>
                        </Table>
                    
                    </Col>
                </Row>
            </CardBody>
        </Card>
};

export default withTranslation(Invoices);